import axios from "axios";
import {usePaging} from "@/modules/reader/book/paging";
import AbstractAnnotations from "@/modules/reader/annotations/AbstractAnnotations";

class PlayKaraokeAnnotation extends AbstractAnnotations{

    static get TYPE() {
        return "playKaraoke"
    }

    constructor(builder) {

        super();
        this.karaokeWordAudiMappedData = {};
        this.fetchAnnotations(builder);

    }

    async fetchAnnotations(builder) {
        const {pageState, setCurrentPage} = usePaging();

        let aimPageBtnId = null;
        let aimPageIndex = null;

        this.annotations.domPos = builder.domPos;

        if (!this.annotationTypes.includes( PlayKaraokeAnnotation.TYPE)) {
            this.annotationTypes.push(PlayKaraokeAnnotation.TYPE);
        }

        this.annotations.isPlayKaraokeBtn = true;

        for (let [key, value] of Object.entries(builder.meta)) {

            if (key === "id") {
                super.setAnnotations({[key]: value});
            } else if (key === "bgImage") {
                super.setAnnotations({[key]:value});
            } else if (key === "grouptag") {
                super.setAnnotations({[key]:value});
            } else if (key === "roleId") {
                super.setAnnotations({[key]:value});
            } else if (key === "icon") {
                super.setAnnotations({"iconSrc": value});
            } else if (key === "setpointurl") {
                super.setAnnotations({"audioId": value});
            } else if (key === "url") {
                super.setAnnotations({"audioSrc": value});
            } else if (key === "aimPageBtnId") {
                aimPageBtnId = value;
                super.setAnnotations({[key]: aimPageBtnId});
            } else if (key === "aimPageIndex") {
                aimPageIndex = parseInt(value);
                super.setAnnotations({[key]: aimPageIndex});
            } else if (key === "hide") {
                if (value === "1") {
                    super.setAnnotations({[key]: parseInt(value)});
                }
            }
        }

        //since aimPageIndex value can be 0, so we check whether it's null to determine if it has value set
        if (aimPageBtnId !== null && aimPageIndex !== null) {
            let btnIdPageMapping = {};
            btnIdPageMapping[aimPageIndex] = aimPageBtnId;
            super.setAnnotations({"btnIdPageMapping": btnIdPageMapping});
        }

        let karaokeWordAudioData = await this.loadKaraokeWordData(builder);

        karaokeWordAudioData.map((el, index) => {
            this.karaokeWordAudiMappedData[builder.availableSpeech[index]] = this.formatKaraokeWordData(el.data, builder)
        });
    }

    async loadKaraokeWordData(builder) {
        let loader = [];

        //append lang abbreviations at the end of the target audio data file name if more than one speech.
        if (builder.availableSpeech.length > 1) {
            for (let speech of builder.availableSpeech) {
                loader.push(await axios.get(`${builder.bookPath}/${builder.meta.setpointurl}_${speech}`));
            }
        } else {
            loader.push(await axios.get(`${builder.bookPath}/${builder.meta.setpointurl}`));
        }

        return  Promise.all(loader);

    }


    formatKaraokeWordData(source, builder) {
        let formattedSource = source.replace(/\s+/g,"");
        let rowData = formattedSource.split("||");
        let result = [];

        //remove the last piece, it's just an empty string ("")  due to extra line break
        rowData.splice(-1);

        for (let [index, item] of Object.entries(rowData)) {

            let rowInnerData = item.split("|");
            let wordDataPieces = [];

            for (let wordData of rowInnerData) {
                wordDataPieces.push(
                    {
                        "duration": parseInt(wordData.split(",")[0]),
                        "increment": parseInt(wordData.split(",")[1])
                    }
                )
            }

            //this line is critical! Update the last word increment data of eac row, so that the rect width, which must be accurate, is chosen!
            wordDataPieces[wordDataPieces.length-1]["increment"] = builder.rowsWidth[builder.meta.grouptag][index]
            result.push(wordDataPieces);
        }

        return result;

    }

    getWordAudioData() {
        return this.karaokeWordAudiMappedData;
    }

}

export default PlayKaraokeAnnotation